define(function (require) {

    // todo - require App!
    var App = window.App || {};

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var BaseFilterViewController = require('web-agent-viewControllers/BaseFilterViewController');
    var ButtonDropdownViewController = require('web-agent-components/ButtonDropdownViewController');

    var FilterDropdownViewController = BaseFilterViewController.extend({
        ControllerName: 'FilterDropdownViewController',
        LPViewMap: {
            dropdownSelection: ".lpview_dropdownSelection",
            tagsContainer: ".lpview_tagsContainer",
            dropDown: ".lpview_dropdown_anchor",
            menuItem: ".menu_item"
        },
        LPClassesMap: {
        },

        initialize: function (constructorData) {
            this.selectedItem = null;
            this.filterName = constructorData.filterName;
            this.filterDataModelPath = constructorData.filterDataModelPath;
            this.controllerModelParam = window.App.agentController.getModelParam(constructorData.filterDataModelPath);
            this.textProperty = constructorData.textProperty || "name";
            this.titleText = constructorData.titleText || "selectValueBelow";
            this.buttonTitleEnabled = constructorData.buttonTitleEnabled || false;
            this.itemsArray = [];
            this.minimumWidth = 150;

            if (constructorData.defaultFilter) {
                this.filterResetData = lpUtils.cloneObject(constructorData.defaultFilter);
                this.filterUIData = lpUtils.cloneObject(this.filterUIData);
                this.filterData = lpUtils.cloneObject(this.filterUIData);
            } else {
                this.filterResetData = null;
                this.filterUIData = null;
                this.filterData = null;
            }


            this.initializeView();
        },
        events: function () {
        },

        render: function () {
        }
    });

    FilterDropdownViewController.prototype.initializeView = function () {
        var tableTemplate = require("web-agent-templates/LP_filter_dropdown_selection_view.html");
        this.createView({template: tableTemplate, target: this.LPViewMap.filterArea });

        // Add Dropdown
        this.DropdownVC = new ButtonDropdownViewController({
            items: this.itemsArray,
            selectedItem: this.selectedItem,
            context: this,
            itemClicked: this.select,
            textProperty: this.textProperty,
            lostFocusCallback: this.onLostFocus,
            rowsSortFunction: this.compare(this.textProperty),
            titleText: this.translate(this.titleText), // Dropdown anchor text,
            buttonTitleEnabled: this.buttonTitleEnabled // Dropdown anchor title enabled/disabled
        });
        this.addViewController({viewController: this.DropdownVC, target: this.LPViewMap.dropdownSelection});
    };

// Check if the user click on one of the buttons (filter/reset/cancel) when closing the dropdown
    FilterDropdownViewController.prototype.onLostFocus = function (e) {
        this.setFocus();
    };

    /**
     * Run on Dropdown change event. Update select lists
     * @param data
     */
    FilterDropdownViewController.prototype.onDropdownChange = function (data) {
        if (data.rowData.id === this.selectedItem.id) {
            this.select(data, false);
        } else {
            this.unSelect();
        }
    };

    FilterDropdownViewController.prototype.select = function (name, disableUpdates) {
        this.selectedItem = name;

        // update the dropdown
        if (typeof disableUpdates !== 'boolean' || !disableUpdates) {
            this.updateFilterUIData();
        } else if (typeof disableUpdates === 'boolean' && disableUpdates) {
            var index = this.findItemIndexByName(name, this);
            this.DropdownVC.setSelectedIndex(index);
        }
    };

    FilterDropdownViewController.prototype.unSelect = function () {
        this.selectedItem = null;

        // update the dropdown
        this.DropdownVC.modelChanged();
        this.updateFilterUIData();
    };

    FilterDropdownViewController.prototype.getItem = function (id) {
        for (var i = 0; i < this.itemsArray.length; i++) {
            if (this.itemsArray[i][this.textProperty].toString() === id.toString()) {
                return this.itemsArray[i];
            }
        }
        return null;
    };

    /**
     * Update the FilterUIDate by the items in the itemsArray
     * go over all the array and get the selected items, them change it to string.
     */
    FilterDropdownViewController.prototype.updateFilterUIData = function () {
        var results = [];

        if (this.selectedItem) {
            results.push(this.selectedItem.rowData[this.textProperty]);
        }
        this.filterUIData = results.length > 0 ? results.toString() : "";
    };

    /**
     * This is the sorting function
     * @param field - the field of the name in the object
     * @returns {Function}
     */
    FilterDropdownViewController.prototype.compare = function (field) {
        function key(x) {
            return x[field];
        }
        return function (a, b) {
            if (parseInt(a.id, 10) < 0) { // if id = -1 then put ot top of the list
                return -1;
            } else if (parseInt(b.id, 10) < 0) {
                return 1;
            }
            if (key(a).toLowerCase() < key(b).toLowerCase()) {
                return -1;
            }
            if (key(a).toLowerCase() > key(b).toLowerCase()) {
                return 1;
            }
            return 0;
        };
    };

    /**
     *  get the list from the model, sort and add -1 value if needed
     * @returns {*}
     */
    FilterDropdownViewController.prototype.getLatestItems = function () {
        this.controllerModelParam = window.App.agentController.getModelParam(this.filterDataModelPath);
        var list = this.controllerModelParam ? lpUtils.cloneObject(this.controllerModelParam) : [];

        return list;
    };

// set the dropdown according to the data in the filter
    FilterDropdownViewController.prototype.updateFilterUI = function () {
        this.selectedItem = null;

        // Clear UI - set selected index to undefined
        this.DropdownVC.setSelectedIndex();

        // Get latest list
        this.itemsArray = this.getLatestItems();

        // Update the dropdown View Controller
        this.DropdownVC.updateModelData(this.itemsArray.sort(this.compare(this.textProperty)));

        // Set selected item
        if (this.filterUIData) {
            var list = this.filterUIData.split(",");
            for (var i = 0; i < list.length; i++) {
                this.select(list[i], true);
            }
        }
    };

    FilterDropdownViewController.prototype.onShow = function () {
        BaseFilterViewController.prototype.onShow.call(this);
    };

    FilterDropdownViewController.prototype.findItemIndexByName = function (name, context) {
        var self = context;
        var items = this.itemsArray.sort(this.compare(this.textProperty));
        var itemIndex = -1;
        _.each(items, function (item, index) {
            if (item[self.textProperty] === name) {
                itemIndex = index;
            }
        });
        return itemIndex;
    };

    return FilterDropdownViewController;

});
